import axios from 'axios';

import { isProductionPortalHost } from '../../helpers/portalHost';

export type AppLoginStatus = {
  hasLoggedIn: boolean;
  timestamp?: string;
};

// clients-onboarding API base. These mirror VITE_API_BASE_URL in
// clients-onboarding/.github/workflows/main.yml: in production the onboarding API
// is reached via the shared api.portal.flipdish.com gateway under the /onboarding
// path; every other portal talks to the clients-integration host directly.
const ONBOARDING_API_BASE = isProductionPortalHost()
  ? 'https://api.portal.flipdish.com/onboarding'
  : 'https://clients-integration.portal.flipdishdev.com';

// Resolves whether the current authenticated user has logged into the Flipdish
// mobile app. The endpoint derives the caller's email from the auth session, so
// the FD-Authorization cookie must be sent (withCredentials).
export async function getUserAppLoginStatus(): Promise<AppLoginStatus> {
  const { data } = await axios.get<AppLoginStatus>(`${ONBOARDING_API_BASE}/user/app-login-status`, {
    withCredentials: true,
  });
  return data;
}
